export function formatMoney(minor: string, currency: string, locale = "en-US"): string {
  try {
    const value = BigInt(minor);
    const isNegative = value < 0n;
    const absolute = isNegative ? -value : value;
    const major = absolute / 100n;
    const fraction = (absolute % 100n).toString().padStart(2, "0");
    return (isNegative ? "−" : "") + currency + " " + major.toLocaleString(locale) + "." + fraction;
  } catch {
    return "Amount unavailable";
  }
}

export function parseMoneyInput(value: string): string | null {
  const normalized = value.trim().replace(/,/g, "");
  const match = /^(-?)(\d+)(?:\.(\d{1,2}))?$/.exec(normalized);
  if (!match) return null;
  const sign = match[1] === "-" ? -1n : 1n;
  const major = BigInt(match[2] ?? "0");
  const fraction = (match[3] ?? "").padEnd(2, "0");
  return (sign * (major * 100n + BigInt(fraction || "0"))).toString();
}

export function formatHouseholdDate(value: string, locale = "en-US"): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
}

export function formatInstant(value: string, timezone: string, locale = "en-US"): string {
  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: timezone,
  }).format(new Date(value));
}

export function titleFromMachineValue(value: string): string {
  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
